import * as Comp from "../../../common/CommonComponents";

const UserListTable = (props) => {
  //#region column
  const columns = [
    {
      accessorKey: "SYSTEM_MST_NAME",
      header: "System Name",
      size: 280,
      accessorFn: (row) => {
        return(
          <div style={{ padding: "10px" }}> 
            <span>{row.SYSTEM_MST_NAME}</span>
          </div>
        );
      },
    },
    {
      accessorKey: "OPEN",
      header: "Open",
      size: 120,
      muiTableBodyCellProps: {
        sx: {
          backgroundColor: '#d9534f',
          color: 'black',
          textAlign: 'center',
        },
      },
    },
    {
      accessorKey: "ACKNOWLEDGE",
      header: "Acknowledged",
      size: 120,
      muiTableBodyCellProps: {
        sx: {
          backgroundColor: '#ffd700',
          color: 'black',
          textAlign: 'center',
        },
      },
    },
    {
      accessorKey: "RESOLVED",
      header: "Resolved",
      size: 120,
      muiTableBodyCellProps: {
        sx: {
          backgroundColor: '#0066cc',
          color: 'black',
          textAlign: 'center',
        },
      },
    },
    {
      accessorKey: "VERIFIED",
      header: "Verified",
      size: 120,
      muiTableBodyCellProps: {
        sx: {
          backgroundColor: '#6F42C1',
          color: 'black',
          textAlign: 'center',
        },
      },
    },
    {
      accessorKey: "CLOSED",
      header: "Closed",
      size: 120,
      muiTableBodyCellProps: {
        sx: {
          backgroundColor: '#2ebf4f',
          color: 'black',
          textAlign: 'center',
        },
      },
    },
    {
      accessorKey: "CANCEL",
      header: "Cancelled",
      size: 120,
      muiTableBodyCellProps: {
        sx: {
          backgroundColor: '#757578',
          color: 'black',
          textAlign: 'center',
        },
      },
    },
    {
      accessorKey: "TOTAL_TICKETS",
      header: "Total Tickets",
      size: 120,
      muiTableBodyCellProps: {
        sx: {
          textAlign: 'center',
          fontWeight: 'bold',
        },
      },
    },
    {
      accessorKey: "TARGET_MANDAYS",
      header: "Utilized Mandays",
      size: 180,
      muiTableBodyCellProps: {
        sx: {
          textAlign: 'center',
        },
      },
    },
  ];
  //#endregion

  return (
    <>
      <Comp.Table
        columns={columns}
        data={props.data}
        table-layout={"auto"}
        invisibleCol={{
          Action: props.actionAuthority.WRITE !== "Y" ? false : true,
        }}
      />
    </>
  );
};

export default UserListTable;
